import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { User } from '@/interfaces/vuex/user';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import { useUserComposable } from '@/composables/useUser';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserPasswordResetDialog',
  props: {
    value: { type: Boolean },
    user: null
  },
  emits: ["input", "reset"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'reset', userId: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  user?: User;
};

const m = defineMessages({
  confirmPasswordReissue: 'パスワードを再発行しますか？',
  sendPasswordResetPrompt:
    '「パスワードを再発行」をクリックすると、以下のメールアドレスにパスワード再発行用のメールが送信されます。',
  completeResetNote:
    '※ 送信後は24時間以内にパスワードの再設定を完了してください。',
});

const { resetCompanyUserPassword } = useUserComposable();





const localValue = ref(props.value);
const isLoading = ref(false);

const closeDialog = () => {
  if (isLoading.value) {
    return;
  }
  localValue.value = false;
  emits('input', false);
};

const handleResetClick = async () => {
  if (!props.user) {
    return;
  }
  try {
    isLoading.value = true;
    await resetCompanyUserPassword(props.user.uuid);
    emits('reset', props.user.uuid);
    isLoading.value = false;
    closeDialog();
  } catch (e) {
    console.error('Failed to reset password:', e);
    isLoading.value = false;
  }
};

const handleCancelClick = () => {
  closeDialog();
};

watch(
  () => props.value,
  (newValue) => {
    localValue.value = newValue;
  }
);

return { __sfc: true,m, resetCompanyUserPassword, props, emits, localValue, isLoading, closeDialog, handleResetClick, handleCancelClick, BaseFormCard, sharedMessages }
}

})